var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicket01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.15629 8.17578C1.93882 8.17578 1.74037 7.9995 1.75036 7.76908C1.80892 6.41976 1.97296 5.54136 2.43257 4.84648C2.697 4.44671 3.02545 4.09902 3.40308 3.81909C4.42378 3.0625 5.86372 3.0625 8.74358 3.0625H12.2565C15.1363 3.0625 16.5763 3.0625 17.597 3.81909C17.9746 4.09902 18.303 4.44671 18.5674 4.84648C19.0271 5.54128 19.1911 6.41957 19.2497 7.76863C19.2596 7.99932 19.0609 8.17578 18.8432 8.17578C17.6306 8.17578 16.6477 9.21637 16.6477 10.5C16.6477 11.7836 17.6306 12.8242 18.8432 12.8242C19.0609 12.8242 19.2596 13.0007 19.2497 13.2314C19.1911 14.5805 19.0271 15.4587 18.5674 16.1536C18.303 16.5533 17.9746 16.901 17.597 17.1809C16.5763 17.9375 15.1363 17.9375 12.2565 17.9375H8.74358C5.86372 17.9375 4.42378 17.9375 3.40308 17.1809C3.02545 16.901 2.697 16.5533 2.43257 16.1536C1.97296 15.4586 1.80892 14.5802 1.75036 13.231C1.74037 13.0005 1.93882 12.8242 2.15629 12.8242C3.36886 12.8242 4.35183 11.7836 4.35183 10.5C4.35183 9.21637 3.36886 8.17578 2.15629 8.17578Z",
    stroke: "#003371",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 3.0625V17.9375",
    stroke: "#003371",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket01);
export default __webpack_public_path__ + "static/media/ticket-01.942f2e162f81ea43ce1c0fa4e3fd8d4c.svg";
export { ForwardRef as ReactComponent };